/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-07.
 * Allow to user edit fields inline
 */
import React, { Component } from 'react';
import { TextField, SelectField, MenuItem, DatePicker, Checkbox } from 'material-ui';
import moment from 'moment';
import { v1 } from 'node-uuid';
import { DropDownSearch, RemoteDropDownSearch } from '../data-containers';
import { extractProperty } from '../../common/helpers';

const getFields = (
    id,
    hint,
    items,
    value = '',
    onChange,
    onAdd,
    entity,
    serviceName,
    url,
    projectionName,
    errorText,

) => {
    var DateTimeFormat = global.Intl.DateTimeFormat;
    return {
        text: <TextField
            id={id}
            hintText={hint}
            value={value || ''}
            onChange={onChange}
            fullWidth
            errorText={errorText}

        />,
        password: <TextField
            id={id}
            hintText={hint}
            value={value || ''}
            onChange={onChange}
            fullWidth
            type="password"
            errorText={errorText}
        />,
        date:
        <DatePicker
            id={id}
            errorText={errorText}
            fullWidth
            floatingLabelFixed
            DateTimeFormat={DateTimeFormat}
            //floatingLabelText="De"
            value={value === null ? null : new Date(value)}
            onChange={(event, newDate) => { onChange(event, newDate); }}
        />,
        select: <SelectField
            id={id}
            fullWidth
            errorText={errorText}
            value={value}
            onChange={(event, newSelected) => { onChange(event, newSelected); }}
        >
            <MenuItem value={'MXN'} primaryText="Pesos (MXN)" />
            <MenuItem value={'USD'} primaryText="Dolares (USD)" />
        </SelectField>,
        autocomplete: <DropDownSearch
            id={id}
            dataSource={extractProperty(items, 'name')}
            errorText={errorText}
            searchText={value}
            onNewRequest={(request, index) => {
                onChange(null, items[index]);
            }}
        />,
        remoteAutocomplete: <RemoteDropDownSearch
            onChange={(selectedValue) => {
                onChange(null, selectedValue);
            }}
            onAdd={onAdd}
            dataSourceConfig={{ text: 'name', value: 'id' }}
            searchText={value}
            entity={entity}
            errorText={errorText}
            serviceName={serviceName}
            url={url}
            projectionName={projectionName}
        />,
        checkbox: <Checkbox
            checked={Boolean(value)}
            onCheck={() => onChange(null, !value)}
            labelStyle={{ color: '#b9b7b7' }}
        />
    };
};


class EditableInlineV2 extends Component {

    constructor(props) {
        super(props);
        this.id = v1();
        this.state = {
            value: props.value
        };
    }

    render() {
        const {
            type = 'text',
            items = [],
            editViewActive,
            hint = '',
            label = '',
            fieldClass = '',
            notify,
            value = '',
            onAdd,
            errorText = '',
            entity = '',
            serviceName = '',
            url = '',
            projectionName = '',
            onDoubleClick = () => { },
            customRender,
            onlyNotify = false
        } = this.props;
        //const { value } = this.state;
        const val = type === 'date' ? (value === null ? value : moment(value).format('DD-MM-YYYY')) : value;
        return (
            <div>
                <p className="text-bold text-color-light">{label}</p>
                <div className={fieldClass} onDoubleClick={onDoubleClick}>
                    {
                        editViewActive ?
                            getFields(
                                this.id,
                                hint,
                                items,
                                value,
                                (event, newValue) => {
                                    !onlyNotify && this.setState({ value: newValue });
                                    notify(newValue);
                                },
                                onAdd,
                                entity,
                                serviceName,
                                url,
                                projectionName,
                                errorText
                            )[type] :
                            <h5>{customRender ? customRender() : (val || '--')}</h5>
                    }
                </div>
            </div>
        );
    }
}

export default EditableInlineV2;



// WEBPACK FOOTER //
// ./components/text/editableInlineV2.js